<template>
  <el-container>
    <el-header>
      <Header />
    </el-header>
    <el-main>
      <div class="error">
        <div>system error</div>
        <div class="message">管理者へお問合せください</div>
        <div class="message">status : {{ $route.params.status }}</div>
        <div class="message">message : {{ $route.params.message }}</div>
      </div>
    </el-main>
    <el-footer>
      <Footer />
    </el-footer>
  </el-container>
</template>
<script>
import Header from '@/components/organisms/Header.vue'
import Footer from '@/components/organisms/Footer.vue'
import { Auth } from 'aws-amplify'

export default {
  components: {
    Header,
    Footer
  },
  data () {
    return {
    }
  },
  mounted () {
    // sessionStorage.removeItem('IdToken')
    Auth.signOut()
    this.$session.destroy()
    document.body.querySelectorAll('.el-dialog__wrapper').forEach(x => x.remove())
  }
}
</script>
<style lang="scss" scoped>
  .error {
    font-size: 2.5em;
    font-style: oblique;
    color: var(--primary-background-color);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    width: 500px;
  }
  .message {
    color: #d7d7d7 !important;
    // font-size: 1em !important;
  }
</style>
